import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Alert from '@cloudscape-design/components/alert';
import Button from '@cloudscape-design/components/button';
import Container from '@cloudscape-design/components/container';
import Form from '@cloudscape-design/components/form';
import FormField from '@cloudscape-design/components/form-field';
import Header from '@cloudscape-design/components/header';
import Input from '@cloudscape-design/components/input';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Spinner from '@cloudscape-design/components/spinner';
import api from '../services/apiService';
import { clearSession } from '../utils/auth';

export default function PasswordResetPage() {
  const { token } = useParams();
  const [metadata, setMetadata] = useState(null);
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [checking, setChecking] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    api.get(`/auth/password-reset/${encodeURIComponent(token)}`)
      .then((response) => setMetadata(response.data))
      .catch((requestError) => setError(requestError.response?.data?.error || 'Der Passwort-Link konnte nicht geprüft werden.'))
      .finally(() => setChecking(false));
  }, [token]);

  async function submit(event) {
    event.preventDefault();
    setError('');
    if (password !== confirmation) {
      setError('Die Passwörter stimmen nicht überein.');
      return;
    }
    setSaving(true);
    try {
      await api.post(`/auth/password-reset/${encodeURIComponent(token)}`, {
        password,
        passwordConfirmation: confirmation,
      });
      clearSession();
      setSuccess(true);
    } catch (requestError) {
      setError(requestError.response?.data?.error || 'Das Passwort konnte nicht geändert werden.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="offer-shell">
      <Container>
        {checking ? <Spinner size="large" /> : success ? (
          <Alert type="success" header="Passwort geändert">
            Das neue Passwort wurde gespeichert. <Link to="/login">Jetzt anmelden</Link>
          </Alert>
        ) : !metadata ? (
          <Alert type="error" header="Link nicht verwendbar">
            {error || 'Der Passwort-Link ist ungültig oder abgelaufen.'} <Link to="/login">Zum Login</Link>
          </Alert>
        ) : (
          <Form
            header={(
              <Header variant="h1" description={`${metadata.tenantName} · ${metadata.loginEmail}`}>
                Neues Passwort festlegen
              </Header>
            )}
            errorText={error}
            actions={<Button variant="primary" loading={saving} onClick={submit}>Passwort speichern</Button>}
          >
            <form onSubmit={submit}>
              <SpaceBetween size="m">
                <Alert type="info">Der Link kann nur einmal verwendet werden.</Alert>
                <FormField label="Neues Passwort" description="Mindestens 10 Zeichen">
                  <Input type="password" value={password} onChange={({ detail }) => setPassword(detail.value)} />
                </FormField>
                <FormField label="Neues Passwort wiederholen">
                  <Input type="password" value={confirmation} onChange={({ detail }) => setConfirmation(detail.value)} />
                </FormField>
              </SpaceBetween>
            </form>
          </Form>
        )}
      </Container>
    </div>
  );
}
